import React from 'react';
import { TreeNodeType } from '../../../../../../lib/types/types';
import FinanzierungPlanSkizzeGlobal, { getFormStrucFinanzierungPlanSkizzeGlobal } from './content/FinanzierungPlanSkizzeGlobal';

export const TreeStructureSkizzeFinanzierungPlanGlobal = (application: any, hasCommentAusgabenUndFinanzierung?: boolean) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Ausgaben- und Finanzierungsplan',
			content: <FinanzierungPlanSkizzeGlobal />,
			formStruc: getFormStrucFinanzierungPlanSkizzeGlobal(application),
			hasComment: hasCommentAusgabenUndFinanzierung,
		},
	];
	return treeNodes;
};
